import { API } from 'aws-amplify';
import { RecurringPayment } from '@/recurring-payments/recurring-payment.model';

export function useRecurringPayments() {
  return {
    fetchRecurringPayments,
    createRecurringPayment,
    updateRecurringPayment,
    deleteRecurringPayment,
  }
}

function fetchRecurringPayments(): Promise<RecurringPayment[]> {
  return API.get('API', '/v1/payor/recurringPayments', {});
}

function deleteRecurringPayment(recurringPaymentId: string) {
  return API.del('API', `/v1/payor/recurringPayments/${recurringPaymentId}`, {});
}

function createRecurringPayment(residentId: string, maxAmount: number, staxPaymentMethodId: string, dayOfMonth: number) {
  return API.post('API', '/v1/payor/recurringPayments', { body: {
      residentId,
      maxAmount,
      staxPaymentMethodId,
      dayOfMonth,
    }
  });
}

function updateRecurringPayment(recurringPaymentId: string, residentId: string, maxAmount: number, staxPaymentMethodId: string, dayOfMonth: number) {
  return API.put('API', `/v1/payor/recurringPayments/${recurringPaymentId}`, { body: {
      residentId,
      maxAmount,
      staxPaymentMethodId,
      dayOfMonth,
    }
  });
}
